/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyRecentIcon = createIcon("EmptyRecentIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    d: "M57 92.5c16.292 0 29.5-13.208 29.5-29.5S73.292 33.5 57 33.5 27.5 46.708 27.5 63 40.708 92.5 57 92.5Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 85.5c15.74 0 28.5-12.76 28.5-28.5S78.74 28.5 63 28.5 34.5 41.26 34.5 57 47.26 85.5 63 85.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 29.5c-15.188 0-27.5 12.312-27.5 27.5S47.812 84.5 63 84.5 90.5 72.188 90.5 57 78.188 29.5 63 29.5ZM33.5 57c0-16.292 13.208-29.5 29.5-29.5S92.5 40.708 92.5 57 79.292 86.5 63 86.5 33.5 73.292 33.5 57Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 38a1 1 0 10-2 0v20a1 1 0 102 0V38Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 57H63a1 1 0 100 2h13a1 1 0 100-2Z",
    fill: "#0C0D0D"
  }));
}, {
  "i18nKey": "svg.EmptyRecentIcon"
});